var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLayoutEffect, useState } from "react";
// I'm not terribly happy with this implementation as any changes in state need to be passed in
// as dependencies to this function so you re-register with updated values...
export function useResizeObserver(callback, deps) {
    useLayoutEffect(function () {
        //useEffect generally calls the function right away, then any time the deps change, so I'm adding this here.
        callback();
        if (typeof window !== "undefined") {
            window.addEventListener("resize", callback);
        }
        return function () {
            if (typeof window !== "undefined") {
                window.removeEventListener("resize", callback);
            }
        };
    }, __spreadArray([callback], deps, true));
}
export function useWindowSize() {
    var _a = useState({
        width: undefined,
        height: undefined,
    }), windowSize = _a[0], setWindowSize = _a[1];
    useLayoutEffect(function () {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }
        if (typeof window !== "undefined") {
            window.addEventListener("resize", handleResize);
        }
        // Call handler right away so state gets updated with initial window size
        handleResize();
        return function () {
            if (typeof window !== "undefined") {
                window.removeEventListener("resize", handleResize);
            }
        };
    }, []);
    return windowSize;
}
//# sourceMappingURL=useResizeObserver.js.map